import moment from "moment";

export default function formatDate(value, fallback = '') {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    } else if (typeof fallback !== "undefined") {
        return fallback
    }
}
